import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Input from '../Input/Input';

const styles = theme => ({
  shift: {
    marginBottom: theme.spacing(1),
  },
});

const firstShiftFields = [
  {
    elementType: 'timePicker',
    config: {
      name: 'firstShiftIni',
      label: 'Início do período',
    },
  },
  {
    elementType: 'timePicker',
    config: {
      name: 'firstShiftEnd',
      label: 'Fim do período',
    },
  },
];

const secondShiftFields = [
  {
    elementType: 'timePicker',
    config: {
      name: 'secondShiftIni',
      label: 'Início do período',
      required: false,
    },
  },
  {
    elementType: 'timePicker',
    config: {
      name: 'secondShiftEnd',
      label: 'Fim do período',
      required: false,
    },
  },
];

const scale = [
  {
    elementType: 'timePicker',
    config: {
      name: 'timeForDays',
      label: 'Horário esperado por dia',
      required: false,
    },
  }
]

const toleranceIn = [
  {
    elementType: 'minuteTimePicker',
    config: {
      name: 'clockInPositiveTolerance',
      label: 'Tolerancia positiva entrada',
      required: false,
    },
  },
  {
    elementType: 'minuteTimePicker',
    config: {
      name: 'clockInNegativeTolerance',
      label: 'Tolerancia negativa entrada',
      required: false,
    },
  }
]

const toleranceOut = [
  {
    elementType: 'minuteTimePicker',
    config: {
      name: 'clockOutPositiveTolerance',
      label: 'Tolerancia positiva saida',
      required: false,
    },
  },
  {
    elementType: 'minuteTimePicker',
    config: {
      name: 'clockOutNegativeTolerance',
      label: 'Tolerancia negativa saida',
      required: false,
    },
  }
]


const ShiftsForm = ({ classes, values, handleChange, isZeroScale, isTolerance,flexScaleHours }) => {

  return (
    <>
      {
        isZeroScale ? scale.map(field => (
          <Grid item key={field.config.name}>
            <Input
              {...field.config}
              elementType={field.elementType}
              value={values[field.config.name]}
              onChange={handleChange(field.config.name)}
              disabled={flexScaleHours}
            />
          </Grid>
        ))
          :
          <React.Fragment>
            <Typography variant="body1" color="textSecondary">
              TURNO 1*
            </Typography>
            <Grid container item xs={9} spacing={2} className={classes.shift} wrap="nowrap">
              {firstShiftFields.map(field => (
                <Grid item key={field.config.name}>
                  <Input
                    {...field.config}
                    elementType={field.elementType}
                    value={isZeroScale ? '0' : values[field.config.name]}
                    onChange={handleChange(field.config.name)}
                    disabled={isZeroScale}
                    style={{ width: '200px' }}
                  />
                </Grid>
              ))}

              {/* {isTolerance ? toleranceIn.map(field => (
                <Grid item key={field.config.name}>
                  <Input
                    {...field.config}
                    elementType={field.elementType}
                    value={values[field.config.name]}
                    onChange={handleChange(field.config.name)}
                    label={<Typography variant="caption">{field.config.label}</Typography>}
                    style={{ width: '200px' }}
                  />
                </Grid>
              )) : ''} */}

            </Grid>

            <Typography variant="body1" color="textSecondary">
              TURNO 2
            </Typography>
            <Grid container item xs={9} spacing={2} wrap="nowrap">
              {secondShiftFields.map(field => (
                <Grid item key={field.config.name}>
                  <Input
                    {...field.config}
                    elementType={field.elementType}
                    value={values[field.config.name]}
                    onChange={handleChange(field.config.name)}
                    disabled={isZeroScale}
                    style={{ width: '200px' }}
                  />
                </Grid>
              ))}
              {/* {isTolerance ? toleranceOut.map(field => (
                <Grid item key={field.config.name}>
                  <Input
                    {...field.config}
                    elementType={field.elementType}
                    value={values[field.config.name]}
                    onChange={handleChange(field.config.name)}
                    label={<Typography variant="caption">{field.config.label}</Typography>}
                    style={{ width: '200px' }}
                  />
                </Grid>
              )) : ''} */}
            </Grid>

          </React.Fragment>
      }
    </>
  )
};

ShiftsForm.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.shape({
    firstShiftIni: PropTypes.string.isRequired,
    firstShiftEnd: PropTypes.string.isRequired,
    secondShiftIni: PropTypes.string.isRequired,
    secondShiftEnd: PropTypes.string.isRequired,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(ShiftsForm);
